import { IContactUs } from "../interfaces/contactUs";
import axios from "./axios";
import { getConfig } from "../utils/sessionStorageUtils";

export const contactUs = async (requestData: any) => {
  try {
    const result = await axios.post(`/ContactUs`, requestData, getConfig());
    return result;
  } catch (e) {
    throw e;
  }
};

export const getContactUsAll = async (url: string) => {
  try {
    const result = await axios.get(`/ContactUs/${url || ""}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getContactUs = async (url: string) => {
  try {
    const result = await axios.get(url, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const changeStatus = async (id: string, status: number) => {
  try {
    const result = await axios.put(`/ContactUs/status-update`, { id, status}, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const deleteContactUs = async (ContactUs: IContactUs) => {
  try {
    const result = await axios.delete(`/ContactUs/${ContactUs?.id}`, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const exportContactUs = async (url: string) => {
  try {
    const result = await axios.get(`/Export/export-data-to-drive/contact-us/${url || ""}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};